/**
 * Destiny map entity hex colors — shared by MapShell GeoJSON, MVT tiles,
 * MapMarker / ClusterMarker (Tailwind blue-600 / purple-600 / yellow-500 / error-600).
 * Values mirror the design tokens in `theme.css` and the exported Figma SVGs.
 */
export const MAP_ENTITY_COLORS = {
	job: "#1570ef",
	record: "#6938ef",
	asset: "#eaaa08",
	ticket: "#d92d20",
} as const;

export type MapEntityColorKey = keyof typeof MAP_ENTITY_COLORS;
